/* global localData */
const filterSection = document.querySelector('.job-filter__dropdown-list');

if (filterSection) {
  const filters = filterSection.querySelectorAll('.dropdown.dropdown--search');
  const selectedFilters = {};
  filters.forEach((filter) => {
    filter.addEventListener('change', (e) => {
      const tempKey = e.target.getAttribute('name');
      selectedFilters[tempKey] = e.target.id;
      AxiosGetFilteredOpenPositions(selectedFilters);
    });
  });

  const AxiosGetFilteredOpenPositions = (selectedFilters) => {
    grecaptcha.ready(async () => {
      const action = 'filterOpenPositions';
      const token = await grecaptcha.execute(localData.captchaSiteKey, { action });
      const formDataInput = {
        action,
        filters: JSON.stringify(selectedFilters),
        lang: localData.lang,
        id: localData.id,
        token,
      };
      const axiosResponse = await axios.post(localData.siteURL, formDataInput, {});
      const htmlResponse = axiosResponse.data.data.html;
      const openPositionsContent = document.querySelector('.open-positions__content');
      document.querySelector('.open-positions__list').innerHTML = htmlResponse;
      openPositionsContent?.classList?.toggle('is-hidden', htmlResponse !== '');
    });
  };

  window.addEventListener('load', () => {
    const params = new URLSearchParams(window.location.search);
    const departmentId = params.get('department');
    if (!departmentId) return;

    const selectedFilters = { department: departmentId };
    AxiosGetFilteredOpenPositions(selectedFilters);

    const openPositions = document.querySelector('.sc-open-positions');
    if (openPositions) {
      const input = openPositions.querySelector(`#${departmentId}`);
      const departmentName = input?.value?.trim();

      if (departmentName) {
        openPositions.querySelector('.dropdown__placeholder-text').textContent = departmentName;
      }

      setTimeout(() => {
        openPositions.scrollIntoView({ behavior: 'smooth' });
      }, 500);
    }
  });
}

const openPositions = document.querySelector('section.sc-open-positions');
const ctaModule = document.querySelector('section.sc-cta-module');

const toggleModal = (value) => {
  const modal = openPositions.querySelector('.form-modal');
  if (modal) {
    modal.classList.toggle('is-open-modal', value);
    const body = document.querySelector('body');
    body.classList.toggle('body-scroll-locked', value);
    document.body.classList.add('is-scrolled');
    document.body.classList.remove('is-scrolled-up');
  }
};

if (openPositions && ctaModule) {
  const button = ctaModule.querySelector('.cta-module__button .btn');
  const closeButton = openPositions.querySelector('.form-modal__close');

  button.addEventListener('click', (e) => {
    const buttonHref = e.target.getAttribute('href');
    if (buttonHref === '#') {
      e.preventDefault();
      toggleModal(true);
    }
  });

  if (closeButton) {
    closeButton.addEventListener('click', () => {
      toggleModal(false);
    });
  }
}

if (window.location.hash === '#application-form') {
  const modal = document.querySelector('.sc-open-positions .form-modal');

  if (modal) {
    modal.classList.add('is-open-modal');
    toggleBodyScrollLock(true);
  }
}
